/**
 * Footer Section - Accordion functionality
 */

(function() {
  'use strict';

  function initFooterAccordions() {
    const accordionHeaders = document.querySelectorAll('.footer__accordion-header');

    accordionHeaders.forEach(function(header, index) {
      // Open first accordion by default
      if (index === 0) {
        header.setAttribute('aria-expanded', 'true');
        const content = header.nextElementSibling;
        if (content) {
          content.classList.add('is-open');
        }
      }

      header.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const content = this.nextElementSibling;

        // Close all other accordions
        accordionHeaders.forEach(function(otherHeader) {
          if (otherHeader !== header) {
            otherHeader.setAttribute('aria-expanded', 'false');
            const otherContent = otherHeader.nextElementSibling;
            if (otherContent) {
              otherContent.classList.remove('is-open');
            }
          }
        });

        // Toggle current accordion
        this.setAttribute('aria-expanded', !isExpanded);
        if (content) {
          content.classList.toggle('is-open', !isExpanded);
        }
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.footer__accordion-header')) {
      initFooterAccordions();
    }
  });
})();
